import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "./style.css";
import Walletsidebar from "../../../components/Wallet_sidebar";
import { currencies } from "../../../constants/jsonConstant";
import axios from "axios";
const WithdrawalMethodForm = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    bankName: "",
    accountNumber: "",
    swiftCode: "",
    country: "",
    currency: "",
    confirm: false,
  });

 const [countrydata, SetCountrydata] = useState([]);
 const [getcountry] = useState();
useEffect(() => {
    axios
      .get(
        "https://pkgstore.datahub.io/core/world-cities/world-cities_json/data/5b3dd46ad10990bca47b04b4739a02ba/world-cities_json.json"
      )
      .then((res) => SetCountrydata(res.data))

      .catch((error) => { });
  }, []);

  const country = [...new Set(countrydata.map((item) => item.country))];

  country.sort();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.confirm) return alert("Please confirm the bank details.");
    console.log("Submitted", formData);
  };

  return (
    <Row>
      <div className="screenHeight d-flex justify-content-around align-items-center p-3">
        <Col
          lg="3"
          xl="2"
          sm="4"
          xs="4"
          md="3"
          className="bg-white shadow-sm h-100 rounded"
          style={{ border: "1px solid #0353a4" }}
        >
          <Walletsidebar />
        </Col>

        <Col lg="8"  className="h-100">
          <Container className="form-wrapper shadow">
            <h3 className="form-title">Set up withdrawal method</h3>
            <p className="important-note">
              <strong>Important Note</strong>
              <br />
              <span className="red-text">
                You can only set up one withdrawal method. Once set up, you can
                only withdraw funds to this account. This is a security measure
                to protect your funds.
              </span>
            </p>

            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Control
                      className="custom-input"
                      name="fullName"
                      placeholder="Enter your full name"
                      value={formData.fullName}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Control
                      className="custom-input"
                      name="bankName"
                      placeholder="Enter your bank name"
                      value={formData.bankName}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Control
                      className="custom-input"
                      name="accountNumber"
                      placeholder="Enter your account number or IBAN"
                      value={formData.accountNumber}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Control
                      className="custom-input"
                      name="swiftCode"
                      placeholder="Enter your branch or SWIFT code"
                      value={formData.swiftCode}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Select
                      className="custom-input"
                      name="country"
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select your country</option>
                      {country
                            
                            .map((country, index) => (
                              <option key={country} value={getcountry}>
                                {country}
                              </option>
                            ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Select
                      className="custom-input"
                      name="currency"
                      value={formData.currency}
                      onChange={handleChange}
                    >
                      <option value="">Select your currency</option>
                     {currencies.map((e) => (
                          <option>
                            {e.abbreviation} {e.name}
                          </option>
                        ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <div className="preview-box mb-3">
                <p className="mb-1 fw-bold">Preview</p>
                <p className="mb-1 font_13">🏦 Account ending in 1234</p>
                <p className="text-muted font_13">Bank of America</p>
              </div>

              <Form.Check
                type="checkbox"
                name="confirm"
                label="I confirm that the bank account details above are correct and belong to me."
                checked={formData.confirm}
                onChange={handleChange}
                className="mb-3"
              />

              <Button type="submit" className="submit-btn">
                Link Withdrawal Method
              </Button>

              <p className="security-note">
                <strong>Security</strong>
                <br />
                Your data is encrypted and securely stored. We recommend
                enabling two-factor authentication (2FA) for added security. You
                may also receive an email confirmation for this setup. If you
                have any questions, please contact our support team.
              </p>
            </Form>
          </Container>
        </Col>
      </div>
    </Row>
  );
};

export default WithdrawalMethodForm;
